import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { getAppConfig } from "./AppConfig";
import { captureError, initErrorTracking } from "./telemetry";
import { identifyStoredSession } from "./state/useAuthStore";
import { i18nReady } from "./i18n";

function registerGlobalErrorHandlers(): void {
  window.addEventListener("error", (event) => {
    captureError(event.error ?? event.message, { source: "window.onerror" });
  });

  window.addEventListener("unhandledrejection", (event) => {
    captureError(event.reason, { source: "unhandledrejection" });
  });
}

async function main() {
  initErrorTracking();
  registerGlobalErrorHandlers();
  identifyStoredSession();

  try {
    getAppConfig();
  } catch (error) {
    console.error("Error loading app config:", error);
    captureError(error, { source: "getAppConfig" });
  }

  await i18nReady;

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

main();
